module.exports = __webpack_public_path__ + "img/soft_12.0e611e79.png";